module.exports = __webpack_public_path__ + "img/arsenal.b1f4293b.png";